// Local replacement for @codemaniack/form-builder card processing utilities

/**
 * Formats card number with spaces (e.g., "4242 4242 4242 4242")
 */
export const processCardNumberInput = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 16 digits
  const limited = digits.slice(0, 16);
  
  // Add space every 4 digits
  const formatted = limited.match(/.{1,4}/g)?.join(' ') || limited;
  
  return formatted;
};

/**
 * Formats expiration date as MM/YY
 */
export const processExpirationDateInput = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 4 digits
  const limited = digits.slice(0, 4);
  
  // Add slash after 2 digits
  if (limited.length >= 3) {
    return `${limited.slice(0, 2)}/${limited.slice(2)}`;
  }
  
  return limited;
};

/**
 * Formats CVV (3-4 digits only)
 */
export const processCVVInput = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 4 digits
  return digits.slice(0, 4);
};
